<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { dataManager, type QuestionnaireRun, type Questionnaire, ResourceType } from '@/dataManager'
import ResourceCard from '@/components/ResourceCard.vue'

const emit = defineEmits<{
  (e: 'backButton', backUrl: string|null): void
}>()

const props = defineProps<{
  id: number
}>()

const router = useRouter()

const dm = dataManager.getInstance()

const questionnaireRun: QuestionnaireRun|null = findLastRun()

const questionnaire = dm.getQuestionnaire(props.id)

const warningTexts = dm.calculateWarningTexts(questionnaire, questionnaireRun)

const recommendedResources = dm.calculateRecommendedResources(questionnaireRun)

onMounted(() => {
  console.log("QuestionnaireResults mounted for questionnaire id " + props.id)
  emit('backButton', '/')

  let user = dm.getCurrentUser()
  if (! user) {
    router.push('/login')
    return;
  }
})

function findLastRun(): QuestionnaireRun|null {
  let user = dm.getCurrentUser()
  if (! user) {
    return null;
  }
  let qRuns = dm.getCurrentUserData().questionnaireRuns

  for (let i = qRuns.length - 1; i >= 0; i--) {
    if (qRuns[i].questionnaireId === props.id) {
      return qRuns[i]
    }
  }
  return null;
}
</script>

<template>
  <div class="content-wrapper">
  <h2>{{ questionnaire.title }}</h2>

  <div v-if="questionnaireRun === null">No has realizado nunca este cuestionario todavía</div>

  <div v-if="questionnaireRun !== null">
    <p v-for="warningText in warningTexts" v-html="warningText"></p>
    <div v-if="recommendedResources.length > 0">
      <h3>Recursos recomendados</h3>
      <ResourceCard v-for="resource in recommendedResources" :resource="resource" />
      <p>Tras cerrar esta pantalla, podrás seguir consultando estes recursos más tarde desde la sección <i>Recursos recomendados</i> desde la pantalla principal.</p>
    </div>
  </div>
  <RouterLink to="/" class="button">OK</RouterLink>
  </div>
</template>

<style scoped>
.content-wrapper {
  max-width: 500px;
}

h2 {
  text-align: center;
}

h3 {
  margin-top: 20px;
}
p {
  margin-top: 10px;
}

button {
  width: 100%;
  max-width: 350px;
  padding: 10px;
}
</style>
